import { render, staticRenderFns } from "./ModalSearchResult.vue?vue&type=template&id=2181b4e9&scoped=true&"
import script from "./ModalSearchResult.vue?vue&type=script&lang=js&"
export * from "./ModalSearchResult.vue?vue&type=script&lang=js&"
import style0 from "./ModalSearchResult.vue?vue&type=style&index=0&id=2181b4e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2181b4e9",
  null
  
)

export default component.exports